<template>
    <div id="zoom-control" class="btn flex-y-center" :style="`opacity: ${styles.opacity}; height: ${CONFIG.timeline.zoom.scrubber.height}; z-index: ${topography}; bottom: ${styles.bottom}px;`" @click="ASSETS.Timeline.Navigation.ToSelection(this, $event)">
        <div class="flex row">
            <Segment
                v-for="(segment, s) in CONFIG.timeline.zoom.max"
                :key="s"
                :zoom="segment"
                :total="CONFIG.timeline.zoom.max"
                :index="s"
            />
        </div>
        <div id="zoom-scrubber" class="btn flex-center" :style="`left: ${scrubber.position}%;`" @mousedown="ASSETS.Timeline.Navigation.Grab(this, $event)">
            <div id="zoom-arrow-left" class="arrow" v-if="scrubber.showLeftArrow"></div>
            <div id="scrubber-bar" class="flex-center" :style="`width: ${CONFIG.timeline.zoom.scrubber.width}px;`">{{ scrubber.position }}</div>
            <div id="zoom-arrow-right" class="arrow" v-if="scrubber.showRightArrow"></div>
        </div>
    </div>
</template>

<script>
import Segment from "@/components/Timeline/ZoomControl/Segment.vue";
import { CONFIG } from "@/assets/JS/Config.js";
import { ASSETS } from "@/assets/JS/Assets.js";
import $ from "jquery";

export default {
    name: "TimelineZoomControl",
    props: {
        styles: Object,
        topography: Number
    },
    components: { Segment },
    data: () => ({
        previousX: 0,
        CONFIG,
        scrubber: {
            position: 0,
            showLeftArrow: false,
            showRightArrow: false
        },
        ASSETS
    }),
    methods: {
        Scrub: function(target) {
            const { zoom } = CONFIG.timeline;
            this.scrubber.position = this.previousX;
            this.previousX = target.clientX;

            // Timeline widths for scrubbing distance definition
            let zoomControlWidth = Number(Math.floor($("#zoom-control").width()));
            zoomControlWidth = zoomControlWidth - zoom.scrubber.width;

            // Check pixel distance of scrubber position, convert to percentages, re-assign to scrubber "left" value
            const pixelDistance = Math.floor((zoomControlWidth / CONFIG.timeline.zoom.max) * 100);
            const percentageDistance = Math.floor((this.scrubber.position / pixelDistance) * 100);
            this.scrubber.position = percentageDistance;

            // Manage scrubbing bounds; disallows control to extend past bounds of timeline
            const positionedLeft = this.scrubber.position <= 1;
            const positionedRight = this.scrubber.position >= 99;
            if (positionedLeft) {
                this.scrubber.position = 0;
            }
            if (positionedRight) {
                this.scrubber.position = 100;
            }
            this.scrubber.showLeftArrow = !positionedLeft;
            this.scrubber.showRightArrow = !positionedRight;

            this.$emit("zoom", this.scrubber.position);
        }
    },
    beforeMount: function() {
        const { max, initial } = CONFIG.timeline.zoom;
        const showScrubberArrows = initial > 0 && initial < max;
        this.scrubber = {
            position: (initial / max) * 100,
            showLeftArrow: showScrubberArrows,
            showRightArrow: showScrubberArrows
        };
    },
    emits: [ "zoom" ]
};
</script>